import { schema } from './workflow'

import { CallApi } from '@signavio/kraken'

export { schema, collection } from './workflow'

export const create =
  (callApi: CallApi, apiBase: string) => (_: unknown, id: string) =>
    callApi(`${apiBase}/workflows/${id}/unlock`, schema, { method: 'POST' })
